import React from "react";
import { Flex, FormControl, FormErrorMessage, FormLabel, Input } from "@chakra-ui/react";
import { Modal, useTranslation, Option } from "@familyzone/component-library";
import { UserSearchSelector } from "../UserSearch/UserSearchSelector";

interface AssociationModalProps {
  open: boolean;
  loading?: boolean;
  onClose: () => void;
  handleSave: (user: string, val: string) => void;
  onChangeMac: (e: React.ChangeEvent<HTMLInputElement>) => void;
  macError: string;
}

const AssociationModal: React.FC<AssociationModalProps> = ({
  open = true,
  onClose,
  handleSave,
  onChangeMac,
  macError,
}: AssociationModalProps) => {
  const { t } = useTranslation();
  const [selectedUser, setSelectedUser] = React.useState<string>();
  const [val, setVal] = React.useState("");

  const handleClick = () => {
    if (selectedUser === undefined) {
      return;
    }
    handleSave(selectedUser, val);
  };

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChangeMac(e);
    setVal(e.target.value);
  };

  const userSelected = (user: Option | null) => {
    if (user && typeof user.value === "string") {
      setSelectedUser(user.value);
    }
  };

  const isValid = !macError && selectedUser && val;

  return (
    <Modal
      headerText={t("Add User")}
      size="md"
      isOpen={open}
      onClose={onClose}
      contentProps={{ style: { overflow: "visible" } }}
      primaryCTALabel={t("Add")}
      primaryCTADisabled={!isValid}
      onPrimaryCTAClick={handleClick}
      secondaryCTALabel={t("Cancel")}
      onSecondaryCTAClick={onClose}
    >
      <Flex mt="sp16" gap="sp16" direction="column">
        <FormControl>
          <FormLabel htmlFor="associationUser-input">{t("User")}</FormLabel>
          <UserSearchSelector id="associationUser" placeholderText="Enter username, email or name" handleChange={userSelected} />
        </FormControl>
        <FormControl isInvalid={!!macError}>
          <FormLabel>{t("Mac/IP Address")}</FormLabel>
          <Input data-testid="macAddress-input" onChange={onChange} />
          <FormErrorMessage fontWeight="regular">{macError}</FormErrorMessage>
        </FormControl>
      </Flex>
    </Modal>
  );
};

export default AssociationModal;
